module.exports = __webpack_public_path__ + "static/media/bg-profile.61ad63f1.jpg";